import React from "react";
import Navbar from "./navbar";
import Body from "./body";
import Works from "./works";
import Footer from "./footer";
function Home(){    
    return <div>
        <meta name="google-site-verification" content="Bhc8D1qu3xWBaIq_0uxW-3trUs9LhRkGvuqRxaVrZkI" />
        <Navbar/>
        <Body/>
        <Works/>
        <Footer/>
    </div>
}
export default Home